import styled from "@emotion/styled";
import { Typography } from "@mui/material";

export const MediaTitle = styled(Typography)`
  margin-left: 2px;
  flex: 1;
`;
